/**
 * @deprecated
 * @service
 * @ngDoc service
 */

import { UserIdha } from "@idha/idha-types";
import { utilsModule } from "../utils-module";

export interface ILoggedUserService {
    loggedUser: UserIdha
    refresh(): void
    verifiedUser: UserIdha
    verifyUser(): UserIdha
}


utilsModule.factory('LoggedUserService', ['localStorageService', 'UserIdha','$ngRedux', function (localStorageService, UserIdha,$ngRedux) {

    var getUserInLocalStorage = function () {

        return localStorageService.get("loggedUser")
    }

    var refresh = async function () {
        var userFromLocalStorage = getUserInLocalStorage();

        if (userFromLocalStorage) {
            let user = await UserIdha.findById({ id: userFromLocalStorage.id, filter: { include: ['person', 'roles', 'currentPhoto','vehicles'] } }).$promise;
            // localStorageService.set("loggedUser", user)
            // LoggedUserService.loggedUser = user;
        }
    }

    const setLoggedUser = function (user) {
        
        // localStorageService.set("loggedUser", user)
    }

    const getLoggedUser = function () {
        return localStorageService.get("loggedUser")
    }

    refresh();


    const LoggedUserService = {
        loggedUser: null,

        refresh: refresh,

        verifiedUser: undefined,
        
        verifyUser: async function () {
            if (!this.verifiedUser) {
                this.verifiedUser = await UserIdha.findById({ id: $ngRedux.getState().loggedUser.id }).$promise;
                await UserIdha.updateLastAccess({ id: $ngRedux.getState().loggedUser.id }).$promise;
            }
            return this.verifiedUser;
        },

        getLoggedUser: getLoggedUser,
        setLoggedUser: setLoggedUser

    }

    return LoggedUserService;

}]);